import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden"]

  connect() {
    const curCountry = this.inputTarget.getAttribute('data-country')
    const inputName = this.inputTarget.getAttribute('data-input')
    const scriptUrl = this.inputTarget.getAttribute('data-script')
    const country = curCountry ? curCountry : 'ru'

    this.iti = window.intlTelInput(this.inputTarget, {
      preferredCountries: ['ru', 'kz', 'by'],
      autoPlaceholder: 'aggressive',
      formatOnDisplay: true,
      strictMode: false,
      separateDialCode: true,
      initialCountry: country,
      utilsScript: scriptUrl,
      customPlaceholder: function (selectedCountryPlaceholder, selectedCountryData) {
        return "XXX-XX-XX";
      }
    })

    // Add input event listener for custom formatting
    this.inputTarget.addEventListener('input', this.formatPhoneNumber.bind(this))
    this.inputTarget.addEventListener('countrychange', this.updateHiddenField.bind(this))
    this.inputTarget.addEventListener('blur', this.updateHiddenField.bind(this))
  }

  formatPhoneNumber(event) {
    let value = event.target.value.replace(/\D/g, '') // Remove all non-digits

    // Apply XXX-XX-XX pattern
    if (value.length >= 3) {
      value = value.substring(0, 3) + '-' + value.substring(3)
    }
    if (value.length >= 7) {
      value = value.substring(0, 7) + '-' + value.substring(7, 9)
    }

    // Limit to XXX-XX-XX format (9 digits max)
    if (value.length > 10) {
      value = value.substring(0, 10)
    }

    event.target.value = value
    this.updateHiddenField()
  }

  updateHiddenField() {
    if (this.iti && this.hasHiddenTarget) {
      const fullNumber = this.iti.getNumber()
      this.hiddenTarget.value = fullNumber
    }
  }

  disconnect() {
    if (this.iti) {
      this.iti.destroy()
    }
  }
}